import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxFontSmBoldProps extends ITextBoxProps {}

export const TextBoxFontSmBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontSmBold,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxFontSmBoldProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    {...rest}
  />
)
